const endSlash = new RegExp(/\/$/);
const startSlash = new RegExp(/^\//);

const assembleUrl = (base) => (path) => {
  const cleanBase = base?.replace(endSlash, '');
  const cleanPath = path?.replace(startSlash, '');

  return `${cleanBase}/${cleanPath}`;
};

const buildUrl = (base, path) => assembleUrl(base)(path);

export { buildUrl };

export const nextQuestionPath = (projectId, orderNumber = null) =>
  `/projects/${projectId}/questions/next${
    orderNumber !== null ? `?order=${orderNumber}` : ''
  }`;

export const submitAnswerPath = (projectId) => `/projects/${projectId}/answers`;

export const submitAnswerBatchPath = (projectId) =>
  `/projects/${projectId}/answers/batch`;

export const fetchSurveyResponsesPath = (projectId) =>
  `/projects/${projectId}/survey`;

export const resetAnswersPath = (projectId) =>
  `/projects/${projectId}/answers/reset`;

export const postResponsesPath = (projectId) =>
  `/projects/${projectId}/diagnostics/finalize`;

export const previousQuestionPath = (projectId, orderNumber = null) =>
  `/projects/${projectId}/questions/previous${
    orderNumber !== null ? `?order=${orderNumber}` : ''
  }`;
